import asset from './assets/man-with-calc.svg'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'

export const DebtConsolidationMan = <InlineSvg src={asset} />
